import { render, staticRenderFns } from "./TabResults.vue?vue&type=template&id=631f561c&scoped=true&"
import script from "./TabResults.vue?vue&type=script&lang=js&"
export * from "./TabResults.vue?vue&type=script&lang=js&"
import style0 from "./TabResults.vue?vue&type=style&index=0&id=631f561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f561c",
  null
  
)

export default component.exports